export enum ClawMachineEnum {
  operationsDetail = 'ClawMachineDetail/OperationsDetail', // 取得選物機帳務清單
  operationsDetailV2 = 'v2/ClawMachineDetail/OperationsDetail', // 新系統：取得選物機帳務清單
  goodsRecord = 'ClawMachineDetail/GoodsRecord', // 商品紀錄清單
  goodsRecordV2 = 'v2/ClawMachineDetail/GoodsRecord', // 新系統：商品紀錄清單
  eventRecord = 'ClawMachineDetail/EventRecord', // 事件紀錄清單
  eventRecordV2 = 'v2/ClawMachineDetail/EventRecord' // 新系統：事件紀錄清單
}
